export const REST_CHAT_DASHBOARD_SETTINGS = '/chatDashboardSettings';
